import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { UserOwner, UserOwnerState } from './user-owner.model'
import { getEnrollment, getUserOwner } from './user-owner.thunk'

const initialState: UserOwnerState = {
  data: undefined,
  error: undefined,
  pending: false,
  isUserProcessing: undefined
}

export const userOwnerSlice = createSlice({
  name: 'userOwner',
  initialState,
  reducers: {
    resetProfile: () => {
      return initialState
    },
    setUserProccesing: (state) => {
      state.isUserProcessing = true;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getUserOwner.pending, (state) => {
      return {
        ...state,
        pending: true,
        error: undefined
      }
    })
    builder.addCase(getUserOwner.fulfilled, (state, action) => {
      return {
        ...state,
        data: action.payload,
        pending: false,
        error: undefined
      }
    })
    builder.addCase(getUserOwner.rejected, (state, action: PayloadAction<unknown>) => {
      return {
        ...state,
        pending: false,
        error: action.payload
      }
    })
    builder.addCase(getEnrollment.pending, (state) => {
      return {
        ...state,
        pending: true,
        error: undefined
      }
    })
    builder.addCase(getEnrollment.fulfilled, (state, action) => {
      return {
        ...state,
        data: action.payload,
        pending: false,
        isUserProcessing: false,
        error: undefined
      }
    })
    builder.addCase(getEnrollment.rejected, (state, action: PayloadAction<unknown>) => {
      return {
        ...state,
        pending: false,
        error: action.payload
      }
    })
  }
})

export const userOwnerReducer = userOwnerSlice.reducer
export const { resetProfile, setUserProccesing } = userOwnerSlice.actions